import {SIZE_CHOICES, getColor, NewMDCButtonComponent} from './new-button.component';

class NormalButtonComponent extends NewMDCButtonComponent{
  constructor($element, $log) {
    'ngInject';
    super($element);
    this.$log = $log;
    this.$log.debug("Btton default size", this.size, "secondary", this.secondary);
    this.size = SIZE_CHOICES.NORMAL;

    this.isDisabled = false;
  }

  getButtonColor() {
    const color = getColor(this.light, this.secondary, false, this.color);
    this.$log.debug("Get color", this.light, this.secondary, this.color, color);
    return color;
  }
}

const config = NewMDCButtonComponent.componentConfig(NormalButtonComponent);

const mod = angular.module('common.materialComponents.normButton', [
])

.component('normButton', config);

export default mod.name;
